import { z } from 'zod';

/** 배송지 수정 입력 — 목록/단건 조회의 SeedingDeliveryAddressItem 과 동일 형태(isPrimary 제외). */
const UpdateDeliveryAddressInputSchema = z.object({
  /** 배송지 ID → PUT body 의 deliveryAddressId. */
  id: z.number().int(),
  addressName: z.string().nullable(),
  name: z.string(),
  phone: z.string(),
  zipcode: z.string(),
  address1: z.string(),
  address2: z.string().nullable(),
  memo: z.string().nullable(),
});

export const UpdateDeliveryAddressServiceRequestSchema = z
  .object({
    campaignId: z.number().int(),
    address: UpdateDeliveryAddressInputSchema,
  })
  .describe('UpdateDeliveryAddressServiceRequest');

export type UpdateDeliveryAddressServiceRequest = z.infer<
  typeof UpdateDeliveryAddressServiceRequestSchema
>;

// 성공 시 반환값을 사용하지 않음(호출부가 상세 invalidate 로 재조회).
export const UpdateDeliveryAddressServiceResponseSchema = z
  .void()
  .describe('UpdateDeliveryAddressServiceResponse');

export type UpdateDeliveryAddressServiceResponse = z.infer<
  typeof UpdateDeliveryAddressServiceResponseSchema
>;
